import styles from './footer.module.css';

const Footer=()=>{ 
    return <div className={styles.main +" text_theme"}> 
            Made with💖By<span className="text-blue">&nbsp;Ankit Kumar</span> &nbsp;<a href="#home"> 🔝</a>
    </div>
}

export default Footer;